import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { MdClose } from "react-icons/md";
import Lottie from "lottie-react";

import CryingAnimation from "../../../../assets/animations/CryingAnimation.json";
import TrophyAnimation from "../../../../assets/animations/Trophy.json";

import useClaimFailedStyles from "./style";
import { UseModalPayload } from "../../../../hooks/useModal";

type ClaimActionResultModalProps = {
  isOpen: boolean;
  payload?: UseModalPayload;
  onClose: VoidFunction;
};

const ClaimActionResultModal = ({
  isOpen,
  payload,
  onClose,
}: ClaimActionResultModalProps) => {
  const { status, message } = payload ?? {};
  const classes = useClaimFailedStyles();

  const animationData =
    status === "success" ? TrophyAnimation : CryingAnimation;
  const dialogTitle = status === "success" ? "Congratulations!" : "Oops!";

  return (
    <>
      <Box component="section">
        <Dialog
          open={isOpen}
          onClose={onClose}
          className={classes.modalpages}
          aria-labelledby="contribution"
          aria-describedby="contribution-result"
          disableEscapeKeyDown={false}
        >
          <Grid
            container
            style={{
              padding: "20px",
              display: "block",
            }}
            direction="column"
          >
            <Grid item style={{
              display: "flex",
              justifyContent: "end"
            }}>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="close"
                onClick={onClose}
              >
                <MdClose />
              </IconButton>
            </Grid>
            <Grid
              item
              lg={12}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Lottie
                animationData={animationData}
                style={{
                  width: "180px",
                  height: "auto",
                }}
              />
            </Grid>
            <Grid item>
              <Grid container justifyContent="center" lg={12}>
                <Grid item lg={12}>
                  <Typography variant="h3" className={classes.progressTitle}>
                    {dialogTitle}
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  <Typography
                    variant="body1"
                    className={classes.progressMessage}
                  >
                    {message}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                justifyContent="center"
                lg={12}
                direction="row"
                style={{
                  marginTop: "20px",
                }}
                spacing={2}
              >
                <Grid item lg={10} xs={10} md={10} sm={10}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={onClose}
                  >
                    Close
                  </Button>
                </Grid>
                {status === "error" && (
                  <Grid item lg={10} xs={10} md={10} sm={10}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      href="https://t.me/GainsSupportBot"
                      target="__blank"
                    >
                      Contact Support
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      </Box>
    </>
  );
};

export default ClaimActionResultModal;
